
import styled from "styled-components"
import { getAdminUyeCalismaSekliYerleri, updateAdminUyeCalismaSekliYerleri } from "../../features/admin2/admin2Slice"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import InputCheckbox from "../shared/input/new/InputCheckbox"
import { useState } from "react"
import { showModal } from "../../features/modal/modalSlice"
import Btn from "../shared/button/Btn"
import locationCityList from "../../utils/locationData/locationCityOptions"
import InputSelectCityMultiple from "../shared/input/new/InputSelectCityMulti"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import {IoCloseCircleOutline} from "react-icons/io5"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};
    max-height: 600px;
    overflow: auto;

    .top-container{
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .name{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }
    }

    .main-content{
        display: flex;
        gap: 40px;


        .side-container{
            width: calc(50% - 20px);
            display: flex;
            flex-direction: column;

            .side-item{
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-bottom: 40px;

                .side-item-top{
                    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                    padding-bottom: 5px;
                    margin-bottom: 10px;

                    h4{
                        font-size: var(--font-size-md);
                        font-size: var(--font-weight-lg);
                    }
                }

                .city-list{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;

                    .city-item{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        border-radius: 10px;
                        width: auto;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        padding: 0 10px;
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        cursor: pointer;

                        .delete-icon{
                            color: #fff;
                            font-size: 1.4rem;
                        }

                        &:hover{
                            background-color: var(--color-main);
                            color: #fff;

                        }
                    }
                }
            }
        }

    }
    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center !important;
        margin-top: auto;
        margin: 30px 0;
        gap: 50px;
    }
`

const AdminUyeCalismaSekliYerleri = () => {

    const { uyeItemData, singleUyeCalismaSekliYerleri } = useSelector(state => state.admin2)
    const dispatch = useDispatch()


    const [isChecked, setIsChecked] = useState()
    const [cityList, setCityList] = useState([])

    const [calismaData, setCalismaData] = useState({})

    useEffect(() => {
        dispatch(getAdminUyeCalismaSekliYerleri(uyeItemData.id))
    },[uyeItemData.id])

    useEffect(() => {
        setCalismaData({
            piyasayaCalisiyorum: singleUyeCalismaSekliYerleri.piyasayaCalisiyorum,
            kendiYukumuTasiyorum: singleUyeCalismaSekliYerleri.kendiYukumuTasiyorum,
            sabitFirmadaCalisiyorum: singleUyeCalismaSekliYerleri.sabitFirmadaCalisiyorum,
            kooperatifeCalisiyorum: singleUyeCalismaSekliYerleri.kooperatifeCalisiyorum,
            hafriyat: singleUyeCalismaSekliYerleri.hafriyat,
            frigorifikSogutuculu: singleUyeCalismaSekliYerleri.frigorifikSogutuculu,
            evdenEve: singleUyeCalismaSekliYerleri.evdenEve,
            konteyner: singleUyeCalismaSekliYerleri.konteyner,
            ambarYuku: singleUyeCalismaSekliYerleri.ambarYuku,
            kargo: singleUyeCalismaSekliYerleri.kargo,
            canlıHayvan: singleUyeCalismaSekliYerleri.canlıHayvan,
            silobas: singleUyeCalismaSekliYerleri.silobas,
            odunTomruk: singleUyeCalismaSekliYerleri.odunTomruk,
            tanker: singleUyeCalismaSekliYerleri.tanker,
            tehlikeliMadde: singleUyeCalismaSekliYerleri.tehlikeliMadde,
            otoKurtarıcıOto: singleUyeCalismaSekliYerleri.otoKurtarıcıOto,
            sadeceSezonluk: singleUyeCalismaSekliYerleri.sadeceSezonluk,
            diger: singleUyeCalismaSekliYerleri.diger,

            //! region
            akdeniz: singleUyeCalismaSekliYerleri.akdeniz,
            doguAnadolu: singleUyeCalismaSekliYerleri.doguAnadolu,
            ege: singleUyeCalismaSekliYerleri.ege,
            guneyDogu: singleUyeCalismaSekliYerleri.guneyDogu,
            icAnadolu: singleUyeCalismaSekliYerleri.icAnadolu,
            karadeniz: singleUyeCalismaSekliYerleri.karadeniz,
            marmara: singleUyeCalismaSekliYerleri.marmara,

        })
    },[singleUyeCalismaSekliYerleri])

    useEffect(() => {
        const cityNameList = singleUyeCalismaSekliYerleri.iller?.split(",") 
        setCityList(locationCityList.map(item =>{
            return {...item, id: item.cityId}
        }).filter(item => {
            return cityNameList?.includes(item.city)
        }))

    },[singleUyeCalismaSekliYerleri])


    const handleChange = ({key, data, isRegion=false, fakeKey=null}) => {
        if(isRegion && data){
            const regioncityList = locationCityList.filter(item => item.region === fakeKey)
            const uniqueList = [...cityList, ...regioncityList].reduce((acc, current) => {
                if(!acc.some(item => item.cityId === current.cityId)){
                    acc.push(current)
                }
                return acc
            },[])
            setCityList(uniqueList)
        }
        if(isRegion && !data){
            const filteredList = cityList.filter((item) => item.region!== fakeKey)
            setCityList(filteredList)
        }
        setCalismaData((prev) => ({ ...prev, [key]: data }));
    }

    const handleDeleteCity = (id) => {
        setCityList(cityList.filter(filterItem => filterItem.cityId !== id))
    }

    const handleSubmit = () => {

        const cities = cityList.map(item => item.city) 
        const cityString = cities.join(",") 

        const data = {
            ...calismaData,
            id:singleUyeCalismaSekliYerleri.id,
            sadeceSezonlukMetin: "",
            digerMetin: "",
            userId: singleUyeCalismaSekliYerleri.userId,
            iller: cityString
        }

        dispatch(updateAdminUyeCalismaSekliYerleri({
            item: data,
            phoneNumber: uyeItemData.phoneNumber
        }))

    }

  return (
    <Container onClick={()=> dispatch(handleActiveSelect(null))}>
        <div className="top-container" >
            <div className="name">Üye Ad Soyad: {uyeItemData?.adSoyadUnvan}</div>
            <InputCheckbox data={isChecked} setData={setIsChecked} labelText={"Size Uygun Yük Bildirimlerinden haberdar olmak ister misiniz?"} fontSize={"14px"}/>
        </div>
        <div className="main-content">
            <div className="side-container">
                <div className="side-item">
                    <div className="side-item-top">
                        <h4>Nereye Çalışıyorsunuz?</h4>
                    </div>
                    <InputCheckbox data={calismaData.piyasayaCalisiyorum} setData={() => handleChange({key:"piyasayaCalisiyorum", data:!calismaData.piyasayaCalisiyorum})} labelText={"Piyasaya"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.kendiYukumuTasiyorum} setData={() => handleChange({key: "kendiYukumuTasiyorum", data: !calismaData.kendiYukumuTasiyorum})} labelText={"Kendi Yüküm"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.sabitFirmadaCalisiyorum} setData={() => handleChange({key: "sabitFirmadaCalisiyorum", data: !calismaData.sabitFirmadaCalisiyorum})} labelText={"Sabit Firmada"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.kooperatifeCalisiyorum} setData={() => handleChange({key: "kooperatifeCalisiyorum", data: !calismaData.kooperatifeCalisiyorum})} labelText={"Kooperatife"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.hafriyat} setData={() => handleChange({key: "hafriyat", data: !calismaData.hafriyat})} labelText={"Hafriyat"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.frigorifikSogutuculu} setData={() => handleChange({key: "frigorifikSogutuculu", data: !calismaData.frigorifikSogutuculu})} labelText={"Frigorifik-Soğutuculu Gıda Yükü"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.evdenEve} setData={() => handleChange({key: "evdenEve", data: !calismaData.evdenEve})} labelText={"Evden Eve (Ev Büro Eşyası)"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.konteyner} setData={() => handleChange({key: "konteyner", data: !calismaData.konteyner})} labelText={"Konteyner"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.ambarYuku} setData={() => handleChange({key: "ambarYuku", data: !calismaData.ambarYuku})} labelText={"Ambar Yükü"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.kargo} setData={() => handleChange({key: "kargo", data: !calismaData.kargo})} labelText={"Kargo"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.canlıHayvan} setData={() => handleChange({key: "canlıHayvan", data: !calismaData.canlıHayvan})} labelText={"Canlı Hayvan"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.silobas} setData={() => handleChange({key: "silobas", data: !calismaData.silobas})} labelText={"Silobas"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.odunTomruk} setData={() => handleChange({key: "odunTomruk", data: !calismaData.odunTomruk})} labelText={"Odun-Tomruk-Orman Ürünleri"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.tanker} setData={() => handleChange({key: "tanker", data: !calismaData.tanker})} labelText={"Tanker"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.tehlikeliMadde} setData={() => handleChange({key: "tehlikeliMadde", data: !calismaData.tehlikeliMadde})} labelText={"Tehlikeli Madde"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.otoKurtarıcıOto} setData={() => handleChange({key: "otoKurtarıcıOto", data: !calismaData.otoKurtarıcıOto})} labelText={"Oto Kurtarıcı-Oto Taşıyıcı-Vinç-Özel Amaçlı"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.sadeceSezonluk} setData={() => handleChange({key: "sadeceSezonluk", data: !calismaData.sadeceSezonluk})} labelText={"Sadece Sezonluk İş"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.diger} setData={() => handleChange({key: "diger", data: !calismaData.diger})} labelText={"Diğer"} fontSize={"14px"} fontWeight={600}/>
                </div>
            </div>
            <div className="side-container">
                <div className="side-item">
                    <div className="side-item-top">
                        <h4>Kayıtlı İller</h4>
                    </div>
                    <div className="city-list">
                        {cityList.map(item => (
                            <div className="city-item" onClick={() => handleDeleteCity(item.cityId)}>{item.city}<IoCloseCircleOutline className="delete-icon"/></div>
                        ))}
                    </div>
                </div>
                <div className="side-item">
                    <div className="side-item-top">
                        <h4>Bölge Seçiniz</h4>
                    </div>
                    <InputCheckbox data={calismaData.marmara} setData={() => handleChange({key: "marmara", fakeKey: "Marmara", data: !calismaData.marmara, isRegion: true})} labelText={"Marmara"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.ege} setData={() => handleChange({key: "ege", fakeKey: "Ege", data: !calismaData.ege, isRegion: true})} labelText={"Ege"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.akdeniz} setData={() => handleChange({key: "akdeniz", fakeKey: "Akdeniz", data: !calismaData.akdeniz, isRegion: true})} labelText={"Akdeniz"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.karadeniz} setData={() => handleChange({key: "karadeniz", fakeKey: "Karadeniz", data: !calismaData.karadeniz, isRegion: true})} labelText={"Karadeniz"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.icAnadolu} setData={() => handleChange({key: "icAnadolu", fakeKey: "İç Anadolu", data: !calismaData.icAnadolu, isRegion: true})} labelText={"İç Anadolu"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.guneyDogu} setData={() => handleChange({key: "guneyDogu", fakeKey: "Güneydoğu Anadolu", data: !calismaData.guneyDogu, isRegion: true})} labelText={"Güneydoğu Anadolu"} fontSize={"14px"} fontWeight={600}/>
                    <InputCheckbox data={calismaData.doguAnadolu} setData={() => handleChange({key: "doguAnadolu", fakeKey: "Doğu Anadolu", data: !calismaData.doguAnadolu, isRegion: true})} labelText={"Doğu Anadolu"} fontSize={"14px"} fontWeight={600}/>
                </div>
                <div className="side-item">
                    <div className="side-item-top">
                        <h4>İl Seçiniz</h4>
                    </div>
                    <InputSelectCityMultiple data={cityList} setData={setCityList} labelText={"İller"} initialOptions={locationCityList} inputWidth={"280px"} name={"calismaYerleriCity"}/>

                </div>
            </div>
        </div>
        <div className="button-grp">
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={handleSubmit}>Güncelle</Btn>
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </Container>
  )
}

export default AdminUyeCalismaSekliYerleri